/** 患者のログインの画面の決まった文言（Issue #473。モックアップ exec-plans/mockups/execplan-backend2-frontend2-infra2-patient-auth-migration-from-cognito/mockup.html）。 */

/** SAS が送る認証コードのメールの件名（backend2 のメールの件名と同じ）。 */
export const SAS_ONE_TIME_PASSWORD_MAIL_SUBJECT =
  "【SASオンラインクリニック】ログインの認証コード";

/** 移行の初回ログインで Cognito が送る認証コードのメールの差出人（infra2/lib/stacks/auth.ts の fromName）。 */
export const COGNITO_ONE_TIME_PASSWORD_MAIL_SENDER = "SASオンラインクリニック";

/**
 * 移行の初回ログインで Cognito が送る認証コードのメールの件名（Cognito の既定の件名。dev・prod とも
 * EmailMfaConfiguration が空なので、この英語の件名で届く。ExecPlan の Q45）。
 */
export const COGNITO_ONE_TIME_PASSWORD_MAIL_SUBJECT =
  "Your authentication code";

/** 移行の期間中（web のフラグが ON の間）、ログインの画面に常に出す案内（Q46）。M10 でフラグと一緒に消す。 */
export const MIGRATION_NOTICE_TITLE = "ログインの画面が新しくなりました";
export const MIGRATION_NOTICE_BODY =
  "ログインIDは、これまでと同じメールアドレスです。パスワードは、最後に決めたものを入力してください。次回からは、この画面をブックマークしてください。";

/** 移行の期間中、PATIENT_AUTH_FAILED のときだけエラーの下に添える。 */
export const MIGRATION_TEMPORARY_PASSWORD_HINT =
  "以前のログインの画面で、初めてのパスワードを決めたばかりの方は、お手元の案内の仮パスワードでお試しください。";

export const NOTICE_MESSAGES = {
  expired: "ログインの有効期限が切れました。もう一度ログインしてください。",
  "signed-out": "ログアウトしました。",
} as const;

/** 初期パスワードを決めた後に、トークンの発行が失敗して最初の段へ戻すときに、失敗の文言の前に添える。 */
export const INITIAL_PASSWORD_SET_PREFIX =
  "新しいパスワードは設定しました。ログインには、新しいパスワードを入力してください。";

/** localStorage に書けず、ログインを終えられないとき（プライベートブラウズ・サイトのデータの保存の拒否）。 */
export const SESSION_STORAGE_UNAVAILABLE_MESSAGE =
  "このブラウザではログインの状態を保存できないため、ログインできません。プライベートブラウズを終えるか、サイトのデータの保存を許可してから、もう一度お試しください。";

/** API の detail が無いとき（通信の失敗・想定外の応答）の文言。 */
export const FALLBACK_ERROR_MESSAGE =
  "時間をおいてもう一度お試しください。解決しない場合はお問い合わせ窓口へご連絡ください。";
